"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translateTransactionType = translateTransactionType;
exports.translateDay = translateDay;
exports.translateTransactionMode = translateTransactionMode;
exports.translateSpecializations = translateSpecializations;
exports.translateUserName = translateUserName;
exports.translateChatToNotification = translateChatToNotification;
const constants_1 = require("../constants");
function translateTransactionType(type) {
    switch (type) {
        case constants_1.TransactionTypeEnum.GATEWAY:
            return 'درگاه پرداخت';
        case constants_1.TransactionTypeEnum.MISCELLANEOUS:
            return 'متفرقه';
        case constants_1.TransactionTypeEnum.REFUND_VISIT_PAYMENT:
            return 'باز پرداخت';
        case constants_1.TransactionTypeEnum.SETTLEMENT:
            return 'تسویه حساب';
        case constants_1.TransactionTypeEnum.STARTER_CHARGE:
            return 'شارژ اولیه';
        case constants_1.TransactionTypeEnum.VISIT_PAYMENT:
            return 'هزینه ویزیت';
    }
}
function translateDay(day) {
    day = Number(day);
    switch (day) {
        case constants_1.DayOfWeek.SUNDAY:
            return 'یکشنبه';
        case constants_1.DayOfWeek.MONDAY:
            return 'دوشنبه';
        case constants_1.DayOfWeek.TUESDAY:
            return 'سه‌شنبه';
        case constants_1.DayOfWeek.WEDNESDAY:
            return 'چهارشنبه';
        case constants_1.DayOfWeek.THURSDAY:
            return 'پنجشنبه';
        case constants_1.DayOfWeek.FRIDAY:
            return 'جمعه';
        case constants_1.DayOfWeek.SATURDAY:
            return 'شنبه';
    }
}
function translateTransactionMode(type, userType) {
    switch (type) {
        case constants_1.TransactionTypeEnum.GATEWAY:
        case constants_1.TransactionTypeEnum.STARTER_CHARGE:
        case constants_1.TransactionTypeEnum.MISCELLANEOUS:
            return 'deposit';
        case constants_1.TransactionTypeEnum.REFUND_VISIT_PAYMENT:
            return userType === constants_1.UserTypeEnum.PATIENT ? 'deposit' : 'withdraw';
        case constants_1.TransactionTypeEnum.VISIT_PAYMENT:
            return userType === constants_1.UserTypeEnum.PATIENT ? 'withdraw' : 'deposit';
        case constants_1.TransactionTypeEnum.SETTLEMENT:
            return 'settlement';
        default:
            return 'withdraw';
    }
}
function translateSpecializations(specializations) {
    if (!specializations?.length) {
        return '';
    }
    return specializations.map((s) => s.name).join(', ');
}
function translateUserName(user) {
    const prefix = user.gender === constants_1.GenderEnum.MALE ? 'آقای ' : constants_1.GenderEnum.FEMALE ? 'خانم ' : '';
    return prefix + user.name;
}
function translateChatToNotification(chat) {
    const title = 'پیام جدید';
    let body = '';
    if (chat.file) {
        const fileType = chat.file?.metadata?.type;
        const fileName = fileType === constants_1.FileTypeEnum.AUDIO ? 'صدا' : 'فایل';
        body = `یک ${fileName} ارسال کرد`;
    }
    else if (chat.text) {
        body = chat.text.split('\n').slice(0, 2).join(' ').substring(0, 140);
    }
    return {
        title,
        body,
    };
}
